import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'emm-delete-consumer-dialog',
  templateUrl: './delete-consumer-dialog.component.html',
  styleUrls: ['./delete-consumer-dialog.component.scss']
})
export class DeleteConsumerDialogComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<DeleteConsumerDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

    ngOnInit(): void {
        this.dialogRef.updatePosition({ top: '100px' });
    }

    closeAfterSubmit(): void {
        const result = {
            tag: this.data.categoryData.tag,
            name: this.data.categoryData.name,
            id: this.data.categoryData.id,
        };
        this.dialogRef.close(result);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    OnSubmit(): void {
        this.closeAfterSubmit();
    }
}
